import { useContext } from "react";
import {
  ListViewSpecificValues,
  PreferenceGroup,
} from "@services/userPreferences/types";
import {
  SpecificPreferencesContext,
  SpecificPreferencesDispatchContext,
  SpecificPreferencesDispatchContextType,
} from ".";

export const useSpecificListPreferences = (): [
  ListViewSpecificValues,
  (data: Partial<ListViewSpecificValues>) => void,
  Omit<SpecificPreferencesDispatchContextType, "update">
] => {
  const { errored, loaded, assetKey, ...data } = useContext(
    SpecificPreferencesContext
  );
  const { update, ...otherDispatches } = useContext(
    SpecificPreferencesDispatchContext
  );
  return [data, update, otherDispatches];
};
